export const personalizationLimit = points => Number(points)>=10?30:20;
export function applyCisPersonalization(result, percentage, points, moralLevel){
 const rate=Number(percentage);
 if(!Number.isFinite(rate)||rate<0||rate>personalizationLimit(points))throw Error('Percentuale di personalizzazione non valida.');
 if(Number(points)<10&&rate>0&&moralLevel)throw Error('Per le microlesioni scegli il morale oppure la personalizzazione, senza sommare i due aumenti.');
 const amount=Number((result.dannoBiologico*rate/100).toFixed(2));
 const total=Number((result.totale+amount).toFixed(2));
 return {...result,personalizzazione:amount,percentualePersonalizzazione:rate,totale:total,totaleSpettante:Number((total*result.responsabilitaControparte/100).toFixed(2))};
}
